import { Injectable } from "@angular/core";

import { Song } from "../models/song.model";

@Injectable()
export class SongService {
    private songs: Song[] = [
        {
            id: 1,
            handle: 'alle-gode-gaver',
            title: 'Alle gode gaver',
            text: `<p>Alle gode gaver,<br/>
            de kommer oven ned,<br/>
            så tak da Gud, ja, pris dog Gud<br/>
            for al hans kærlighed.</p>`
        },
        {
            id: 2,
            handle: 'i-jesu-navn-gaar-vi-til-bord',
            title: 'I Jesu navn går vi til bord',
            text: `<p>I Jesu navn går vi til bord<br/>
            at spise, drikke på dit ord<br/>
            Dig Gud til ære, os til gavn<br/>
            Så får vi mad i Jesu navn</p>`
        },
        {
            id: 3,
            handle: 'du-har-aabnet-mine-oejne',
            title: 'Du har åbnet mine øjne',
            text: `<p>Du har åbnet mine øjne<br/>
            Du har mættet min sjæl<br/>
            Overøst mig med gode gave<br/>
            og gjort alle ting vel.</p>`
        },
        {
            id: 4,
            handle: 'ham-takker-alle-vi-med-sang',
            title: 'Ham takker alle vi med sang',
            text: `<p>Ham takker alle vi med sang<br/>
            for alt, hvad han har givet,<br/>
            for hvad han vokse lod i vang,<br/>
            for ordet og for livet.</p>`
        },
        {
            id: 5,
            handle: 'tak-for-alle-gode-gaver-som-du-skaenket-har',
            title: 'Herre, Herre, Herre, Herre',
            text: `<p>: Herre, Herre, Herre, Herre<br/>
            Tak for alle gode gaver,<br/>
            som du skænket har.:<br/><br/>
            Med musik og glade takkesange<br/>
            vil vi takke dig for gaver mange.<br/>
            Med musik og glade takkesange<br/>
            vil vi synge højt din pris.</p>`
        },
        {
            id: 6,
            handle: 'naar-fuglen-bliver-maettet-saa-synger-den-glad',
            title: 'Når fugle bli\'r mættet, så synger den glad',
            text: `<p>Når fugle bli'r mættet, så synger den glad.<br/>
            Når blomsten bli'r vandet, så stråler dens blad.<br/>
            Hvor meget des mere må jeg da være glad.<br/>
            Og takke min skaber for drikke og mad.</p>`
        },
        {
            id: 7,
            handle: 'o-du-som-maetter-liden-fugl',
            title: 'O, du som mætter liden fugl',
            text: `<p>O, du som mætter liden fugl,<br/>
            velsign vor mad, o Gud.<br/>
            For helse, klæde, dagligt brød,<br/>
            vi takker dig, o Gud.</p>`,
            melody: 'Kan synges på melodien "Emil fra Lønneberg" eller "Der sad to katte på et bord".'
        },
        {
            id: 8,
            handle: 'i-jesu-navn-gaar-vi-til-bord',
            title: 'I Jesu navn går vi til bord',
            text: `<p>I Jesu navn går vi til bord<br/>
            at spise, drikke, på hans ord<br/>
            dig Gud til ære os til gavn,<br/>
            så får vi mad i Jesu navn.</p>`,
        },
        {
            id: 9,
            handle: 'det-hammer-hammer-fedt',
            title: 'Det’ hammer hammer fedt',
            text: `<p>Det’ hammer hammer fedt,<br/>
            vi spiser lig’ om lidt.<br/>
            Maden den er klar,<br/>
            den kommer fra vor far.<br/>
            Den ligger godt i maven,<br/>
            vi takker dig for gaven.<br/>
            Hallelu ja, værs’go’ og begynd!</p>`,
            melody: 'Synges på melodien: "Det er hammer hammer fedt".'
        },
        {
            id: 10,
            handle: 'glaedens-herre-vær-vor-gaest',
            title: 'Glædens Herre, vær vor gæst',
            text: `<p>Glædens Herre, vær vor gæst<br/>
            ved vort bord i dag.<br/>
            Gør vort måltid til en fest<br/>
            efter dit behag.</p>`,
        },
        {
            id: 11,
            handle: 'tak-den-brune-ko-for-kakaomaelk',
            title: 'Tak den brune ko',
            text: `<p>Tak den brune ko for kakaomælk!<br/>
            Tak en gris (øf øf) for min frikadellemad!<br/>
            Tak til hønen for ægget og ægget for kyllingen…<br/>
            og Gud som skabte alt – Amen!</p>`,
            credits: 'Tekst: Maria Swartz Pfrogner'
        },
        {
            id: 12,
            handle: 'nogle-har-mad-men-kan-ikke-spise',
            title: 'Nogle har mad',
            text: `<p>Nogle har mad, men kan ikke spise.<br/>
            Andre kan spise, men har ingen mad.<br/>
            Jeg takker dig Gud, jer er så glad,<br/>
            for jeg kan spise, og jeg har mad!</p>`,
            credits: 'Original tekst på engelsk af: Robert Burns'
        },
        {
            id: 13,
            handle: 'hvem-maetter-blaahvalen',
            title: 'Hvem mætter blåhvalen?',
            text: `<p>Hvem mætter blåhvalen? Det gør Gud!<br/>
            Hvem mætter elefanten? Det gør Gud!<br/>
            Hvem mætter os ved bordet? Det gør Gud<br/>
            Velsign vor mad O Gud, Amen.</p>`,
            melody: 'Melodi: He’s got the whole world in his hands'
        },
        {
            id: 14,
            handle: 'mad-halleluja-amen',
            title: 'Mad, halleluja!',
            text: `<p>Mad, halleluja!<br/>
                    Amen!</p>`,
        },
        {
            id: 15,
            handle: 'for-de-gaver-som-du-giver',
            title: 'For de gaver som du gir\'',
            text: `<p>For de gaver som du gir'<br/>
                    takker vi dig nu,<br/>
                    Gud som hører før vi ber´,<br/>
                    priset være du.</p>`,
            credits: 'Tekst: Hans D. Stern'
        },
        {
            id: 16,
            handle: 'thank-you-lord-for-giving-us-food',
            title: 'Thank you Lord for giving us food',
            text: `<p>Thank you Lord for giving us food (x3)<br/>
                    Right where we are<br/>
                    Hallelujah praise the Lord (x3).<br/>
                    Right where we are<br/>
                    Amen!</p>`,
            credits: 'Tekst: Hans D. Stern'
        },
        {
            id: 17,
            handle: 'du-gode-gud',
            title: 'Du gode Gud',
            text: `<p>Du gode Gud<br/>
                    velsign du maden<br/>
                    Amen!</p>`,
        },
    ];

    public Get(searchQuery: string = undefined): Song[] {
        if (searchQuery != undefined) {
            // Validate that searchQuery is valid.
            if (searchQuery.length < 2) return [];

            searchQuery = searchQuery.toLowerCase();
            return this.songs.filter(x => x.title.toLowerCase().includes(searchQuery) || x.text.toLowerCase().includes(searchQuery));
        }

        return this.songs;
    }

    public GetByHandle(handle: string): Song {
        return this.songs.filter(x => x.handle.toLowerCase() == handle.toLowerCase())[0];
    }

    public GetRandom(bannedTitles?: string[]): Song {
        if (bannedTitles != null && bannedTitles.length > 0) {
            keys = Object.keys(this.songs.filter(x => bannedTitles.find(y => y == x.title) == null));
            return this.songs.filter(x => bannedTitles.find(y => y == x.title) == null)[keys[keys.length * Math.random() << 0]];
        } else {
            var keys = Object.keys(this.songs);
            return this.songs[keys[keys.length * Math.random() << 0]];
        }
    }

    public GetForToday(): Song {
        const now = new Date();
        const start = new Date(now.getFullYear(), 0, 0);
        const diff = (now as any) - (start as any);

        const oneDay = 1000 * 60 * 60 * 24;
        const dayOfYear = Math.floor(diff / oneDay);

        let songIndex = 0;

        for (let i = 0; i < dayOfYear; i++) {
            if (songIndex >= this.songs.length - 1) {
                songIndex = 0;
            } else {
                songIndex++;
            }
        }

        return this.songs[songIndex];
    }

    public CountSongs(): number {
        return this.songs.length;
    }

}